import ErreursConstante from "../../../_constantes/erreursConstantes.json";
import { AdministrateurBienDetail, Site } from "../../../services/Api/swagger";

export interface ISelectAdbSiteFormData {
  adb: string;
  site: string;
}

export interface ISelectAdbSiteFormError {
  adb?: string;
  site?: string;
}

export const construireListAdb = (listAdb: AdministrateurBienDetail[]) => {
  return listAdb
    ? listAdb.map((s) => ({
        key: s.identifiant || 0,
        text: s.nom || "",
        value: s.identifiant ? String(s.identifiant) : "",
      }))
    : [];
};

export const construireListSite = (listSite: Site[]) => {
  return listSite
    ? listSite.map((s) => ({
        key: s.numero || 0,
        text: s.nom || "",
        value: s.numero ? String(s.numero) : "",
      }))
    : [];
};

export const validateForm = (
  values: ISelectAdbSiteFormData
): ISelectAdbSiteFormError => {
  const errors: ISelectAdbSiteFormError = {} as ISelectAdbSiteFormError;

  if (!values.adb) {
    errors.adb = ErreursConstante.formulaire.generale.adbObligatoire;
  }

  if (!values.site) {
    errors.site = ErreursConstante.formulaire.generale.siteObligatoire;
  }

  return errors;
};
